import { render, staticRenderFns } from "./nutritionSaleForm.vue?vue&type=template&id=a09c33d2&scoped=true"
import script from "./nutritionSaleForm.vue?vue&type=script&lang=js"
export * from "./nutritionSaleForm.vue?vue&type=script&lang=js"
import style0 from "./nutritionSaleForm.vue?vue&type=style&index=0&id=a09c33d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09c33d2",
  null
  
)

export default component.exports